import * as React from 'react'
import * as css from './ServicesList.module.css'
import HTag from 'components/common/HTag'
import { graphql, Link, useStaticQuery } from 'gatsby'
import Img from 'components/common/Img'
import { clsx } from 'clsx'

const ServicesList = ({ heading, description, items }) => {
	const { services } = useStaticQuery(query)
	const list = items?.length ? items : services.nodes

	return (
		<section className="py-16">
			<header className="richtext mx-auto max-w-screen-md px-4 text-center">
				<HTag className="h0 <md:h1" {...heading} />
				{!!description && (
					<p className="mx-auto max-w-[650px]">{description}</p>
				)}
			</header>

			<div className="mt-16 md:ml-auto">
				<div className="grid gap-[1px] md:ml-[8vw] md:grid-cols-2 <md:gap-y-6">
					{list?.map((service, key) => (
						<Service {...service} key={key} />
					))}
				</div>
			</div>
		</section>
	)
}

const Service = ({
	title,
	description,
	listingDescription,
	image,
	blocks,
	url,
	seo,
}) => {
	const [hero] = blocks || []

	const content = (
		<>
			<Img
				className="inset-0 grayscale md:!absolute"
				image={image || hero?.image?.image}
				alt={title}
			/>

			<div className={`${css.txt} gradient-ft-green`}>
				<div>
					<h3 className="technical-lg text-xl">{title} ➞</h3>
					<p className={`${css.desc} mt-2`}>
						{description || listingDescription}
					</p>
				</div>
			</div>
		</>
	)

	if (!url && !seo?.slug.current)
		return (
			<div
				className={clsx(
					'relative bg-suede-black md:aspect-[1.5] md:pr-8 md:pt-12',
					css.service,
				)}
			>
				{content}
			</div>
		)

	return (
		<Link
			className={clsx(
				'relative bg-suede-black md:aspect-[1.5] md:pr-8 md:pt-12',
				css.service,
			)}
			to={url || `/services/${seo.slug.current}`}
		>
			{content}
		</Link>
	)
}

export default ServicesList

const query = graphql`
	query ServicesList {
		services: allSanityServicesPg(
			filter: { title: { ne: "Renewable Energy EPC Services" } }
		) {
			nodes {
				title
				listingDescription
				blocks {
					... on SanityHero {
						image {
							image {
								asset {
									gatsbyImageData(placeholder: NONE, aspectRatio: 1.3)
								}
							}
						}
					}
				}
				seo {
					slug {
						current
					}
				}
			}
		}
	}
`
